import { getApiClient } from '@apps/web/lib/api_client';
import { type ApiBodyType } from '@libraries/typescript/api_client';

// Both settings surfaces use these descriptors for reads and writes so their
// request targets and cache keys always identify the same membership.
export function notificationPreferencesRequest(
    organizationId: string | null,
    memberUserId?: string,
) {
    return memberUserId
        ? ({
              path: '/organizations/{organization_id}/members/{member_user_id}/notification-preferences',
              pathParams: organizationId
                  ? {
                        organization_id: organizationId,
                        member_user_id: memberUserId,
                    }
                  : undefined,
          } as const)
        : ({
              path: '/users/me/notification-preferences',
              queryParams: organizationId
                  ? { organization_id: organizationId }
                  : undefined,
          } as const);
}

export function notificationFollowsRequest(
    organizationId: string | null,
    memberUserId?: string,
) {
    return memberUserId
        ? ({
              path: '/organizations/{organization_id}/members/{member_user_id}/notification-follows',
              pathParams: organizationId
                  ? {
                        organization_id: organizationId,
                        member_user_id: memberUserId,
                    }
                  : undefined,
          } as const)
        : ({
              path: '/organizations/{organization_id}/users/me/notification-follows',
              pathParams: organizationId
                  ? { organization_id: organizationId }
                  : undefined,
          } as const);
}

export type MemberProfileSettingsUpdate = Pick<
    ApiBodyType<'/users/me/org-member-profiles/{organization_id}', 'patch'>,
    'notification_phone_number' | 'assigned_office_ids'
>;

export async function updateMemberProfileSettings(
    organizationId: string,
    body: MemberProfileSettingsUpdate,
    memberUserId?: string,
): Promise<void> {
    if (memberUserId) {
        const { notification_phone_number, ...sharedFields } = body;
        await getApiClient().patch({
            url: '/organizations/{organization_id}/users/{user_id}',
            pathParams: {
                organization_id: organizationId,
                user_id: memberUserId,
            },
            body: {
                ...sharedFields,
                ...(notification_phone_number !== undefined
                    ? { phone_number: notification_phone_number }
                    : {}),
            },
        });
    } else {
        await getApiClient().patch({
            url: '/users/me/org-member-profiles/{organization_id}',
            pathParams: { organization_id: organizationId },
            body,
        });
    }
}
